import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { apiUrl } from "../../config/Config";

const CreateUserModal = ({ isOpen, onClose, onSave }) => {
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [showLoading, setShowLoading] = useState(false);

  // Input field states
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  // Keeping default role as 'Admin' as it's still a valid option
  const [role, setRole] = useState('admin'); 
  const [password, setPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');

  // Updated roles: removed 'Super'
  const roles = ['admin', 'superadmin'];

  const handleSave = async() => {
    // Basic client-side validation
    if (!firstName || !lastName || !email || !number || !password || !retypePassword) {
      alert("Please fill in all required fields.");
      return;
    }
    if (password !== retypePassword) {
      alert("Passwords do not match.");
      return;
    }

    setShowLoading(true);
    
    const data = {
      firstname: firstName,
      lastname: lastName,
      email: email,
      mobile: number,
      type: role,
      password: password,
      retypepassword: retypePassword,
    };
  
    console.log("Sending data:", data);
    console.log("Token:", userdata?.token);

    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
  
    try {
      const res = await axios.post(apiUrl + 'createaccount', data, headers);
      if (res.data.status === 'success') {
        console.log("User created successfully.");
        alert("User created successfully!");
        onSave();
        onClose();
        // Reset form fields after successful creation
        setFirstName('');
        setLastName('');
        setEmail('');
        setNumber('');
        setRole('admin'); // Reset to default 'Admin'
        setPassword('');
        setRetypePassword('');
      } else {
        alert(res.data.message || "Failed to create account. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      alert("Error creating user: " + (err.response?.data?.message || err.message || "Network error."));
    } finally {
      setShowLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="user-modal-overlay">
      <div className="user-modal-container">
        <div className="user-modal-header">
          <h2 className='createpost-modal-title'>Add New User</h2>
          <button onClick={onClose} className="user-modal-close-btn">
            <X size={20} />
          </button>
        </div>

        <form className="user-modal-form" onSubmit={(e) => e.preventDefault()}>
          <div className="user-modal-group">
            <div className="user-modal-field">
              <label>First Name</label>
              <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} required />
            </div>
            <div className="user-modal-field">
              <label>Last Name</label>
              <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} required />
            </div>
          </div>

          <div className="user-modal-field">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>

          <div className="user-modal-field">
            <label>Phone Number</label>
            <input type="text" value={number} onChange={e => setNumber(e.target.value)} required />
          </div>

          <div className="user-modal-field">
            <label>Role</label>
            <select value={role} onChange={e => setRole(e.target.value)}>
              {roles.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>

          <div className="user-modal-group">
            <div className="user-modal-field">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <div className="user-modal-field">
              <label>Retype Password</label>
              <input type="password" value={retypePassword} onChange={e => setRetypePassword(e.target.value)} required />
            </div>
          </div>

          <div className="user-modal-footer">
            <button type="button" className="user-modal-cancel" onClick={onClose} disabled={showLoading}>Cancel</button>
            <button type="submit" className="user-modal-submit" onClick={handleSave} disabled={showLoading}>
              {showLoading ? 'Adding...' : 'Add User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateUserModal;